import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchSurveyStatus = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `games/roulette/restaurants/${restaurantId}/setting/is-survey/` : null;
  const { data: surveyStatus, error, isLoading } = useSwrNoAuth<boolean>(fetcherKey)
  return { surveyStatus, isLoading, error };
};